import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root =
  ({ isFullscreen }: { isFullscreen: boolean }) =>
  (theme: ExactTheme) => {
    return [
      css`
        height: 100%;
        background-color: ${theme.colorsV2.white};
        border: 1px solid ${theme.colorsV2.grey[100]};
        position: sticky;
        top: 0;
        border-radius: 6px;
        //box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.25); //  todo: move to theme

        flex-shrink: 0;
        overflow: hidden;
      `,
      isFullscreen
        ? css`
            width: 321px;

            @media ${theme.deviceV2.greaterThan.laptop} {
              width: 407px;
            }

            @media ${theme.deviceV2.greaterThan.desktop} {
              width: 540px;
            }
          `
        : css`
            width: 321px;

            @media ${theme.deviceV2.greaterThan.laptopL} {
              width: 407px;
            }
          `,
    ];
  };
